import Vue from 'vue'
import axios from 'axios'

// state
export const state = {
  isLeaguesLoading: false,
  selectedLeagueId: null,
  all: {},
}

// getters
export const getters = {
  getLeaguesForSelectedSport: ({ all }, getters, { 'sports/index': { selectedSportId } }) => all[selectedSportId] || [],
  getLeaguesForSport: ({ all }) => ({ sportId }) => all[sportId] || [],
  getSelectedLeague: ({ all, selectedLeagueId }, getters, { 'sports/index': { selectedSportId } }) => {
    if (all[selectedSportId]) {
      return all[selectedSportId].find(({ id }) => id === selectedLeagueId)
    }
    return false
  },
}
// mutations
export const mutations = {
  fetchLeaguesStarted(state) {
    state.selectedLeagueId = null
    state.isLeaguesLoading = true
  },
  fetchLeaguesSuccess(state, { sportId, leagues }) {
    Vue.set(state.all, sportId, leagues)
    state.isLeaguesLoading = false

    if (!state.selectedLeagueId && leagues.length) {
      state.selectedLeagueId = leagues[0].id
    }
  },
  fetchLeaguesFailed(state) {
    state.isLeaguesLoading = false
  },
  switchSelectedLeague(state, { leagueId }) {
    state.selectedLeagueId = leagueId
  },
}
// actions
export const actions = {
  async fetchLeagues({ commit, state: { all, selectedLeagueId } }, { sportId }) {
    if (typeof all[sportId] !== 'undefined') {
      if (!all[sportId].find(({ id }) => selectedLeagueId === id)) {
        let leagueId = null
        if (all[sportId].length) {
          leagueId = all[sportId][0].id
        }
        commit('switchSelectedLeague', { leagueId })
      }
      return all
    }
    let leagues = null
    try {
      commit('fetchLeaguesStarted')
      leagues = await axios.get(`sport/${sportId}/leagues`)
      commit('fetchLeaguesSuccess', { sportId, leagues })
    } catch (e) {
      commit('fetchLeaguesFailed')
    }
    return leagues
  },
  async switchSelectedLeague({ commit }, { leagueId }) {
    commit('switchSelectedLeague', { leagueId })
  },
}
